/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PaginatedEventResponseList } from '../schemas/PaginatedEventResponseList';
import { fetcher, FetcherOptions } from './fetcher';

export interface ListEventsAPIQueryParams {
  analytics_script_ran_successfully?: boolean;
  description?: string;
  /**
   * @format date-time
   */
  end_time?: string;
  /**
   * @format date-time
   */
  end_time_gt?: string;
  /**
   * @format date-time
   */
  end_time_gte?: string;
  /**
   * @format date-time
   */
  end_time_lt?: string;
  /**
   * @format date-time
   */
  end_time_lte?: string;
  have_broadcasts?: boolean;
  have_discussions?: boolean;
  host_type?: string;
  internal_session_checkin?: boolean;
  is_onsite?: boolean;
  limit?: number;
  offset?: number;
  ordering?: string;
  organization?: string;
  series?: string;
  series_type?: 'default' | 'repeating';
  short_name?: string;
  /**
   * @format date-time
   */
  start_time?: string;
  /**
   * @format date-time
   */
  start_time_gt?: string;
  /**
   * @format date-time
   */
  start_time_gte?: string;
  /**
   * @format date-time
   */
  start_time_lt?: string;
  /**
   * @format date-time
   */
  start_time_lte?: string;
  tag?: string[];
  title?: string;
  user?: string;
  user_email?: string;
  vivenu_event_id?: string;
  workspace?: string;
  workspace__isnull?: boolean;
}

export type ListEventsOkResponse = PaginatedEventResponseList;

export type ListEventsErrorResponse = unknown;

export interface ListEventsProps
  extends Omit<FetcherOptions<ListEventsAPIQueryParams, unknown>, 'url'> {
  queryParams: ListEventsAPIQueryParams;
}

export function listEvents(
  props: ListEventsProps
): Promise<ListEventsOkResponse> {
  return fetcher<ListEventsOkResponse, ListEventsAPIQueryParams, unknown>({
    url: `/event/`,
    method: 'GET',
    ...props
  });
}
